/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Connections_Disconnect_AriaInputs */



/**
* | output |
* | --- |
* | "Disconnect {name}" |
*
* @param {Connections_Disconnect_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_disconnect_aria = /** @type {((inputs: Connections_Disconnect_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Disconnect_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} trennen`)
	return /** @type {LocalizedString} */ (`Disconnect ${i?.name}`)
});